module.exports = __webpack_public_path__ + "static/img/transition-day-before-exam.1c7f7c7.png";